import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  getCouponsListApi,
  getIssuedCouponListApi,
  issueCouponApi,
} from '@src/api/coupons';
import { CouponListParams } from '@src/api/coupons/coupons';

const getIssuedCouponList = createAsyncThunk(
  'coupons/getIssuedCouponList',
  async (params: CouponListParams, { rejectWithValue }) => {
    try {
      const response = await getIssuedCouponListApi(params);
      return response.result.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const getCouponOptionList = createAsyncThunk(
  'coupons/getOptions',
  async (search: string, { rejectWithValue }) => {
    try {
      const response = await getCouponsListApi({ search });
      return response.result.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const issueCoupon = createAsyncThunk(
  'coupon/issue',
  async (
    { id, companyId }: { id: string; companyId: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await issueCouponApi(id, companyId);
      return response;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        throw rejectWithValue(err.response?.data);
      }
    }
  }
);

export { getIssuedCouponList, getCouponOptionList, issueCoupon };
